import { Box, Tooltip } from '@mui/material'
import { FormattedMessage } from 'react-intl'

const cutTemplate = require('../assets/cut-template.gif')

const CutOverlay = ({ fill = '#000000', width = '100%', height = '100%' }) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={width}
        height={height}
        fill={fill}
        viewBox='0 0 422 150'>
        <title>Cut Overlay</title>
        <path
            fill='#FFFFFF'
            fillRule='evenodd'
            d='m211 148c0 1.1 0 2 0 2h-211v-150h422v150h-211c0 0-0.1-2 0-2c89.5 0 195.3-22.3 209-73c-10.6-48.5-123-73-195-73c0 0-14 15-14 15c0 0-14.5-15.1-14.5-15.1c-69.9 0-181.1 23.8-193.5 73.1c10.3 46.3 106.1 73 208 73z'
            clipRule='evenodd'
        />
    </svg>
)

interface TagProps {
    cuts?: Snitt[]
    show?: 'full' | 'right' | 'left'
    showToolTip?: boolean
    selectPosition?: (possitionKey: number) => void
}

export const Ear = ({
    cuts = [],
    show = 'full',
    showToolTip = false,
    selectPosition,
}: TagProps) => {
    const onEarPosClicked = (positionKey: number) => {
        selectPosition && selectPosition(positionKey)
    }

    const getToolTipText = (position: number) => {
        if (!showToolTip) return ''
        const text = cuts.find(
            (cut) => cut.posisjon === position
        )?.bokstavkombinasjon
        if (text) {
            return (
                <FormattedMessage
                    id={'component.ear.delete'}
                    values={{ x: text }}
                />
            )
        }
        const positionText =
            position === 1 || position === 6 ? (
                <FormattedMessage id={'component.ear.top'} />
            ) : position === 3 || position === 4 ? (
                <FormattedMessage id={'component.ear.bottom'} />
            ) : (
                <FormattedMessage id={'component.ear.edge'} />
            )

        return (
            <FormattedMessage
                id={'component.ear.choose-cut'}
                values={{
                    pos: positionText,
                }}
            />
        )
    }

    return (
        <Box
            sx={{
                maxWidth: '35rem',
                overflow: 'hidden',
                margin: '0 auto',
            }}>
            <Box
                sx={{
                    position: 'relative',
                    width:
                        show === 'left' || show === 'right' ? '200%' : '100%',
                    marginLeft:
                        show === 'right'
                            ? '-101.5%'
                            : show === 'left'
                            ? '1.5%'
                            : '0',
                }}>
                <Box sx={{ width: '100%' }}>
                    <img
                        src={cutTemplate}
                        style={{ width: '100%' }}
                        alt='Reinmerke-bilde'
                    />
                </Box>
                {cuts?.map((el) => (
                    <Box sx={{ position: 'absolute', top: 0, width: '100%' }}>
                        <img
                            style={{ width: '100%' }}
                            alt='Reinmerke-bilde'
                            src={`data:image/gif;base64,${el?.bilde}`}
                        />
                    </Box>
                ))}
                <Box sx={{ position: 'absolute', top: 0, width: '100%' }}>
                    <CutOverlay width='100%' height='100%' />
                </Box>
                <Tooltip
                    arrow
                    enterDelay={1200}
                    title={getToolTipText(1)}
                    placement='top'>
                    <Box
                        onClick={() => onEarPosClicked(1)}
                        sx={{
                            position: 'absolute',
                            top: 0,
                            bottom: '50%',
                            right: 0,
                            left: '50%',
                        }}
                    />
                </Tooltip>
                <Tooltip
                    arrow
                    enterDelay={1200}
                    title={getToolTipText(3)}
                    placement='bottom'>
                    <Box
                        onClick={() => onEarPosClicked(3)}
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            bottom: 0,
                            right: 0,
                            left: '50%',
                        }}
                    />
                </Tooltip>
                <Tooltip
                    arrow
                    enterDelay={1200}
                    title={getToolTipText(2)}
                    placement='right'>
                    <Box
                        onClick={() => onEarPosClicked(2)}
                        sx={{
                            position: 'absolute',
                            top: 0,
                            bottom: 0,
                            right: 0,
                            left: '85%',
                        }}
                    />
                </Tooltip>
                <Tooltip
                    arrow
                    enterDelay={1200}
                    title={getToolTipText(6)}
                    placement='top'>
                    <Box
                        onClick={() => onEarPosClicked(6)}
                        sx={{
                            position: 'absolute',
                            top: 0,
                            bottom: '50%',
                            right: '50%',
                            left: 0,
                        }}
                    />
                </Tooltip>
                <Tooltip
                    arrow
                    enterDelay={1200}
                    title={getToolTipText(4)}
                    placement='bottom'>
                    <Box
                        onClick={() => onEarPosClicked(4)}
                        sx={{
                            position: 'absolute',
                            top: '50%',
                            bottom: 0,
                            right: '50%',
                            left: 0,
                        }}
                    />
                </Tooltip>
                <Tooltip
                    arrow
                    enterDelay={1200}
                    title={getToolTipText(5)}
                    placement='left'>
                    <Box
                        onClick={() => onEarPosClicked(5)}
                        sx={{
                            position: 'absolute',
                            top: 0,
                            bottom: 0,
                            right: '85%',
                            left: 0,
                        }}
                    />
                </Tooltip>
            </Box>
        </Box>
    )
}

export default Ear
